import React, { Component, Fragment } from 'react';
import { Query, Mutation, withApollo } from "react-apollo";
import { Formik } from 'formik';
import { gerenciarGruposLocaisOne, gerenciarGruposLocaisSave } from '../../../graphql/GrupoLocal';
import autoBind from 'react-autobind';
import { Button, Col, Form, Row, Container, ButtonToolbar } from 'react-bootstrap';
// import { gerenciarSalasSave } from '../../../graphql/Salas';
import * as Yup from 'yup';

const { Control, Group, Label } = Form;
const { Feedback } = Control;

const selectStyle = {
  control: (base, state) => ({
    ...base,
    border: '1px solid #c0c0c0',
    boxShadow: 'none',
    '&:hover': {
    border: '1px solid #c0c0c0',
    }
  })
};

const GrupoLocalSchema = Yup.object().shape({
    nome: Yup.string().required('Nome precisa ser preenchido'),
});


class GrupoLocalWidgetForm extends Component {
  constructor(props) {
    super(props);

    this.registro_inicial = {
        id: null,
        nome: "",
    }

    this.state = {
        _v: 0,
        arquivado: false,
    };

    autoBind(this);
  }

  componentDidMount() {}

  handleSaveForm(data) {
    const { client, handleModalClose } = this.props;

    client.mutate({
      mutation: gerenciarGruposLocaisSave,
      variables: { input: Mutation.cleanupData(data) },
      // variables: { input: data },
    }).then(() => handleModalClose());
  }

  notifyChange() {
    this.setState({ _v: this.state._v + 1 });
  }

  render() {
    const { handleModalClose, id } = this.props;
    const readOnly = this.props.action === 'view';

    return (
      <Fragment>
        <Container>
          <Row className="justify-content-sm-center">
            <Col sm="12" as={Row} className="justify-content-sm-between">
              <h3>{this.props.action === "edit" ? "Editar" : this.props.action === "view" ? "Ver" : "Novo"}</h3>
              <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-secondary-get">Fechar</Button>
            </Col>
          </Row>
        </Container>

        <Container className="popup-content">
          <Row className="justify-content-md-center">
            <Col sm="12">
              <Query query={gerenciarGruposLocaisOne} skip={!id} variables={{ id }}>
                {({ error, data, loading }) => {
                  if (loading) return "Buscando dados";
                  if (error) return `Erro ao buscar dados: ${error.message}`;

                  let formData = { ...this.registro_inicial };

                  if (data) {
                    formData = { ...data.grupoLocalOne };
                  }

                  return (
                    <Formik
                      validateOnMount={true}
                      initialValues={{ ...formData, id: id || -1 }}
                      onSubmit={(data) => {
                          this.handleSaveForm(data);
                      }}
                      validationSchema={GrupoLocalSchema}
                    >
                      {props => {
                        const {
                          handleChange, handleSubmit, values, errors, touched,
                        } = props;

                        const onChange = (event) => {
                          handleChange(event);
                          this.notifyChange();
                        }

                        return (
                          <Fragment>
                            <Form onSubmit={handleSubmit}>
                              <input id="arquivado" type="hidden" value={values.arquivado} />

                              <Row className="form-body-row">
                                <Col sm="12">
                                  {/* Nome */}
                                  <Group as={Row}>
                                    <Label column sm="3">Nome: </Label>
                                    <Col sm="4">
                                      <Control id="nome" name="nome" readOnly={readOnly} onChange={onChange} type="text" value={values.nome} isValid={!touched.nome ? undefined : !errors.nome} isInvalid={!touched.nome ? undefined : !!errors.nome} />
                                        {errors.nome && touched.nome
                                          ? (
                                              <Feedback type="invalid">{errors.nome}</Feedback>
                                            )
                                          : null}
                                    </Col>
                                  </Group>

                                  {/* Espaço (para as opções do select quando o Fórmula está oculto) */}
                                  <br /><br /><br /><br />
                                </Col>
                              </Row>

                              {/* Botões */}
                              <Row className="form-buttons-row">
                                <Col sm="12">
                                  <Group>
                                    <ButtonToolbar>
                                      <Button onClick={() => handleModalClose()} variant="secondary" className="btn-secondary-get">Fechar</Button>
                                      {this.props.action !== 'view' ? <Button type="submit" variant="primary" className="btn-primary-get">Salvar</Button> : null}
                                    </ButtonToolbar>
                                  </Group>
                                </Col>
                              </Row>
                            </Form>
                          </Fragment>
                        )
                      }}
                    </Formik>
                  )
                }}
              </Query>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withApollo(GrupoLocalWidgetForm);